<template>
  <div class="device-params-wrap flex flex-row justify-between items-center gap-1 text-14px">
    <div class="flex-1 ">
      <span class="w-full text-14px">Light Color</span>
      <div class="text-center item-height">
        <DropdownDeviceLevelLight :level="level" :disabled="disabled" @change="onLevelDropdown" :is-bluetooth="isBluetooth"/>
      </div>

    </div>
    <div class="flex-1 ">
      <span class="text-14px">Resistance</span>
      <div class="text-center item-height">{{ resistance }}</div>
    </div>

    <div class="flex-1 ">
      <span class="text-14px">Max Power</span>
      <div class="text-center item-height">10W</div>
    </div>
  </div>
</template>


<script>
import DropdownDeviceLevelLight from "@/components/home/DropdownDeviceLevelLight.vue";

export default {
  name: "DeviceParams",
  components: { DropdownDeviceLevelLight },
  props: {
    r: {
      type: Number,
      default: 1.2
    },
    level: {
      type: Number,
      default: 1
    },
    disabled: {
      type: Boolean,
      default: true // NFC BT
    },
    isBluetooth: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      dropdownMenuWidth: 0,
      dropdownMenuLeft: 0
    };
  },
  methods: {
    onLevelDropdown(value) {
      this.$emit("change", value);
    }
  },
  computed: {
    resistance() {
      if (this.r === -1) {
        return "No Value";
      }
      return `${this.r}Ω`;
    }
  },
  mounted() {
  }
};
</script>

<style scoped lang="less">
.device-params-wrap {
  width: 100%;
  font-size: 14px;
  text-align: start;
}


/deep/ .van-dropdown-item__option {
  img {
    width: 22px;
    height: 22px;
  }
}


.drop-item-level__wrap {
  width: 100%;
  padding: 0px 8px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}

.drop-item-level__content {
  width: 20px;
  height: 20px;
  margin-left: 10px;
  border: 1px #999 solid;
  border-radius: 50%;
}


/deep/ .van-dropdown-menu__bar {
  height: 32px;
  box-shadow: none;
  background: transparent;

  .van-dropdown-menu__item {
    justify-content: flex-start;
  }

  .van-dropdown-menu__title {
    font-size: 11px;
    color: #939598;
    flex: 1;

    &::after {
      margin-right: 15px;
    }
  }

  .van-dropdown-menu__title--active {
    color: #939598;
  }

  .van-dropdown-menu__title::after {
    top: 42%;
    color: #d1d3d4;
    border: 4px solid #d1d3d4;
    border-color: transparent transparent #d1d3d4 #d1d3d4;
  }
}

.item-height {
  height: 32px;
  line-height: 32px;
  border: 1px solid #E8E8E8;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
}

</style>